import { c as createFocusTrap } from './focus-trap.esm-MYAhwz8v.js';
import { onClickOutside } from './utils-on-click-outside.js';

class DropdownElement extends HTMLElement {
  static {
    // Let the document listen for clicks on dropdown controllers
    document.addEventListener('click', (event) => {
      const controller = event.target.closest('[data-dropdown-controller]');
      const dropdownId = controller?.getAttribute('aria-controls');
      if (!dropdownId) return;

      const dropdown = document.getElementById(dropdownId);
      if (!dropdown) {
        console.error(`Dropdown with id '${dropdownId}' not found`);
        return;
      }
      dropdown.handleAction('toggle');
      event.preventDefault();
    });
  }

  connectedCallback() {
    // Create the focus trap
    this.trap = createFocusTrap(this, {
      // Allow clicks outside the modal to close the dropdown
      allowOutsideClick: true,
      initialFocus: false,
    });

    // Listen for key:escape events
    this.unsubscribeEscapeKey = subscribe('key:escape', () => this.close());

    // Listen for clicks outside the dropdown
    onClickOutside(this, () => this.close());
  }

  disconnectedCallback() {
    this.unsubscribeEscapeKey();
  }

  /**
   * Handle dropdown actions
   * @param {string} action - The action to perform ('open', 'close', or 'toggle')
   */
  handleAction(action) {
    switch (action) {
      case 'open':
        this.open();
        break;
      case 'close':
        this.close();
        break;
      default:
        this.toggle();
        break;
    }
  }

  /**
   * Toggle the dropdown
   */
  toggle() {
    this.ariaHidden === 'true' ? this.open() : this.close();
  }

  /**
   * Open the dropdown
   */
  open() {
    if (this.ariaHidden === 'false') return;
    this.ariaHidden = false;
    this.updateControllers();
    this.trap.activate();
  }

  /**
   * Close the dropdown
   */
  close() {
    if (this.ariaHidden === 'true') return;
    this.trap.deactivate();
    setTimeout(() => {
      this.ariaHidden = true;
      this.updateControllers();
    }, 100);
  }

  /**
   * Update the aria-expanded attribute on dropdown controllers
   */
  updateControllers() {
    document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((element) => {
      element.setAttribute('aria-expanded', this.ariaHidden === 'false' ? 'true' : 'false');
    });
  }
}

customElements.define('dropdown-element', DropdownElement);

export { DropdownElement };
